module.exports = __webpack_public_path__ + "media/images/mobile/mb-hamburger0-22a78987a8e2c0c8bfd42362ee854427.png";